import { isRouteErrorResponse, Link, useRouteError } from "react-router";

export function RouteErrorBoundary() {
  const error = useRouteError();
  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : "页面加载时发生了未知错误";

  return (
    <section className="mx-auto max-w-2xl rounded-lg border border-border bg-surface p-8 shadow-panel">
      <p className="text-sm font-semibold text-danger-600">页面暂时不可用</p>
      <h1 className="mt-2 text-2xl font-semibold text-ink">请重新进入该页面</h1>
      <p className="mt-3 text-ink-muted">{message}</p>
      <Link
        to="/"
        className="mt-6 inline-flex rounded-md bg-brand-600 px-4 py-2 text-sm font-semibold text-white outline-none hover:bg-brand-700 focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-2"
      >
        返回首页
      </Link>
    </section>
  );
}
